/**
 * Класс данных реквизитов счёта.
 */
export class AccountDetailData {
  /**
   * Получатель.
   */
  public BankName: string = "";

  /**
   * ИНН.
   */
  public Inn: string = "";

  /**
   * КПП.
   */
  public Kpp: string = "";

  /**
   * Расчётный счёт.
   */
  public Rs: string = "";

  /**
   * Банк получателя.
   */
  public RecepientName: string = "";

  /**
   * Корреспонденсткий счёт.
   */
  public Ks: string = "";

  /**
   * БИК.
   */
  public Bik: string = "";

  /**
   * Назначение платежа.
   */
  public Info: string = "";

  /**
   * Ссылка на QR-код.
   */
  public QrUrl: string = "";

  public SwiftBankName: string = "";

  public KorrBankName: string = "";

  public SwiftKorrBankName: string = "";

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  public constructor(src: any = null) {
    if (src) {
      const result = src.Data.InnerData.Data[0].Properties;

      if (result == null) return;

      this.BankName = result.BankName ?? "";
      this.Inn = result.Inn ?? "";
      this.Kpp = result.Kpp ?? "";
      this.Rs = result.Rs ?? "";
      this.RecepientName = result.RecepientName ?? "";
      this.Ks = result.Ks ?? "";
      this.Bik = result.Bik ?? "";
      this.Info = result.Info ?? "";
      this.QrUrl = result.QrUrl ?? "";
      this.SwiftBankName = result.SwiftBankName ?? "";
      this.KorrBankName = result.KorrBankName ?? "";
      this.SwiftKorrBankName = result.SwiftKorrBankName ?? "";
    }
  }
}
